import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';
import {TranslatePipe} from '@ngx-translate/core';
import {IconComponent} from '../../icons/icon.component';

@Component({
  imports: [MatDialogModule, TranslatePipe, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss'
})
export class ConfirmDialogComponent {
  readonly data = inject<ConfirmDialogData>(MAT_DIALOG_DATA);

  get isDangerAction(): boolean {
    return this.data.action === 'danger';
  }
}

export interface ConfirmDialogData {
  title: string,
  body: string,
  hint?: string,
  action?: 'danger' | 'primary',
  confirmLabel: string
  cancelLabel?: string
}
